import $ from 'jquery';
import wNumb from 'wnumb';
import noUiSlider from 'nouislider';
import mergeTooltips from './nouislider-merge-tooltips.js';
import 'nouislider/dist/nouislider.css';

class VehiclesCatalog {
    constructor(el) {
        this.$el = $(el);

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$vehiclesList = this.$el.find('.vehicles-catalog__results');
        this.$loadingIndicator = this.$el.find('.vehicles-catalog__loading-indicator');
        this.$filtersForm = this.$el.find('.vehicles-catalog__filters');
        this.$priceRangeSlider = this.$el.find('.price-range-slider');
        this.$filtersGroupsAccordions = this.$el.find('.dropdown-check-list .anchor');
        this.$filterBar = this.$el.find('.list-products__mobile-layout');
        this.$filterSubmit = this.$el.find('.list-product_filter-button');
        this.$closePanelButton = this.$el.find('.vehicles-catalog__close-filters-panel-button');
        this.$orderInput = this.$el.find('.vehicles-catalog__order');
        this.$overlay = this.$el.parent().find('.vehicles-catalog__overlay');
        this.$minPriceInput = this.$filtersForm.find('input[name="prix-min"]');
        this.$maxPriceInput = this.$filtersForm.find('input[name="prix-max"]');
        this.$paginationInput = this.$filtersForm.find('input[name="pagination"]');
        this.$body = $('body');

        this.isBusy = false;
        this.noUiSlider = null;
        this.paginationOffset = this.$paginationInput.val();
        this.endReached = this.$el.hasClass('vehicles-catalog--end-reached');
        
        if(this.$vehiclesList.length) {
            this._createPriceRangeSlider();
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onScrollFn = this._onScroll.bind(this);
        this.onLoadResultsStartFn = this._onLoadResultsStart.bind(this);
        this.onLoadResultsEndFn = this._onLoadResultsEnd.bind(this);
        this.onFiltersSubmitFn = this._onFiltersSubmit.bind(this);
        this.onFilterToggleFn = this._onFilterToggle.bind(this);
        this.onPriceFilterChangeFn = this._onPriceFilterChange.bind(this);

        this.$filterSubmit.on('click', function() {
            this.$filtersForm.removeClass('filters--openned');
			this.$overlay.removeClass('panel--openned');
            this.$body.removeClass('filters--openned');
        });

        this.$filterBar.on('click', function() {
            this.$filtersForm.toggleClass('filters--openned');
			this.$overlay.toggleClass('panel--openned');
            this.$body.toggleClass('filters--openned');
        });

        this.$closePanelButton.on('click', function() {
            this.$filtersForm.removeClass('filters--openned');
			this.$overlay.toggleClass('panel--openned');
            this.$body.removeClass('filters--openned');
        });

        this.$filtersGroupsAccordions.on('click', this.onFilterToggleFn);
        this.$filtersForm.on('submit', this.onFiltersSubmitFn);
        this.$filtersForm.find('input').on('change', this.onFiltersSubmitFn);
        this.$orderInput.on('change', this.onFiltersSubmitFn);
        this.noUiSlider.on('change', this.onPriceFilterChangeFn);
        window.addEventListener('scroll', this.onScrollFn);
        window.addEventListener('popstate', (e) => {
            console.log("location: " , document.location , ", state: " , JSON.stringify(e.state), e);
            this._resetFiltersValues();
            this._setFiltersValues(e.state);
            this._loadResults(true, true);
        });
    }

    _unbindEvents() {
        this.$filtersGroupsAccordions.off('click', this.onFilterToggleFn);
        this.$filtersForm.off('submit', this.onFiltersSubmitFn);
        this.noUiSlider.off('change', this.onPriceFilterChangeFn);
        this.$orderInput.off('change', this.onFiltersSubmitFn);
        this.noUiSlider.off('change', this.onPriceFilterChangeFn);
        window.addEventListener('scroll', this.onScrollFn);
    }

    _createPriceRangeSlider() {
        const min = parseInt(this.$priceRangeSlider.attr('data-min'), 10);
        const max = parseInt(this.$priceRangeSlider.attr('data-max'), 10);
        const start = parseInt(this.$priceRangeSlider.attr('data-value-min'), 10);
        const end = parseInt(this.$priceRangeSlider.attr('data-value-max'), 10);
        
        noUiSlider.cssClasses.target += ' range-slider';

        this.noUiSlider = noUiSlider.create(this.$priceRangeSlider[0], {
            start: [start, end],
            tooltips: true,
            connect: true,
            step: 1000,
            range: {
                min: min,
                max: max
            },
            format: wNumb({
                suffix: ' €',
                decimals: 0,
                thousand: ' '
            })
        });
        mergeTooltips(this.$priceRangeSlider[0], 40, ' - ');
        
        // Define initial price hidden inputs values with slider values
        const priceRange = this.noUiSlider.get(true);
        this.$minPriceInput.val(parseInt(Math.round(priceRange[0]), 10));
        this.$maxPriceInput.val(parseInt(Math.round(priceRange[1]), 10));
    }

    _onScroll() {
        // const {scrollHeight} = document.documentElement;
        const scrollHeight = this.$el.offset().top + this.$el.outerHeight();

        if(window.pageYOffset + window.innerHeight >= scrollHeight && !this.endReached && !this.isBusy && !this.$el.hasClass('vehicles-catalog--end-reached')) {
            this.paginationOffset ++;
            this.$paginationInput.val(this.paginationOffset);
            
            this._loadResults();
        }
    }

    _onFilterToggle(e) {
        const {target} = e;

        if(target.parentNode.classList.contains('visible')) {
            target.parentNode.classList.remove('visible');
        }
        else {
            target.parentNode.classList.add('visible');
        }
    }

    _onPriceFilterChange(e) {
        // Update price hidden inputs values with slider values
        const priceRange = this.noUiSlider.get(true);
        this.$minPriceInput.val(parseInt(Math.round(priceRange[0]), 10));
        this.$maxPriceInput.val(parseInt(Math.round(priceRange[1]), 10));

        this._onFiltersSubmit();
    }

    _onFiltersSubmit(e = null) {
        if(e) e.preventDefault();

        this.$el.removeClass('vehicles-catalog--end-reached');
        this.endReached = false;
        this.paginationOffset = 0;
        this.$paginationInput.val(this.paginationOffset);
        this._loadResults(true);
    }

    _getFiltersValues() {
        const priceRange = this.noUiSlider.get(true);
        const sort = this.$orderInput.length && this.$orderInput[0].value.match(/.+-.+/) ? this.$orderInput[0].value.split('-') : ['default', ''];
        const filters = {
            // Filters
            prix: [parseInt(Math.round(priceRange[0]), 10), parseInt(Math.round(priceRange[1]), 10)],
            'carrosserie': [],
            'marque': [],
            'modele': [],
            'motorisation': [],
            
            // Pagination
            pagination: this.paginationOffset,

            // Ordering
            order: sort[1],
            orderby: sort[0],
        };

        const filtersGroups = [
            document.querySelectorAll('input[name="carrosserie[]"]:checked'),
            document.querySelectorAll('input[name="marque[]"]:checked'),
            document.querySelectorAll('input[name="modele[]"]:checked'),
            document.querySelectorAll('input[name="motorisation[]"]:checked')
        ];
        
        filtersGroups.forEach((filterGroup) => {
            if(filterGroup.length) {
                filterGroup.forEach((filter) => {
                    const fieldName = filter.name.replace('[]', '');
                    
                    if(filters?.[fieldName]) {
                        filters?.[fieldName].push(filter.value);
                    }
                });
            }
        });

        return filters;
    }

    _resetFiltersValues() {
        const checkedInputs = [...this.$filtersForm[0].querySelectorAll('input:checked')];
        
        // Reset checked inputs
        if(checkedInputs.length) {
            checkedInputs.forEach((input) => {input.checked = false;});
        }
        
        // Reset prices slider
        if(this.noUiSlider) {
            this.noUiSlider.set([this.noUiSlider.options.range.min, this.noUiSlider.options.range.max]);
            this.$minPriceInput.val(this.noUiSlider.options.range.min);
            this.$maxPriceInput.val(this.noUiSlider.options.range.max);
        }

        // Reset pagination input
        this.$paginationInput.val(0);
        
        // Reset order combobox
        this.$orderInput[0].options[0].selected = true;
        
        console.log('form reset');
    }

    _setFiltersValues(state) {
        for(const key in state) {
            switch(key) {
                case 'prix':
                
                    if(Array.isArray(state[key]) && state[key].length === 2) {
                        const minVal = parseInt(state[key][0], 10);
                        const maxVal = parseInt(state[key][1], 10);

                        if(!isNaN(minVal) && !isNaN(maxVal) && minVal >= this.noUiSlider.options.range.min && maxVal <= this.noUiSlider.options.range.max) {
                            this.$minPriceInput.val(minVal);
                            this.$maxPriceInput.val(maxVal);
                            this.noUiSlider.set([minVal, maxVal]);
                        }
                    }
                break;

                case 'carrosserie':
                case 'marque':
                case 'modele':
                case 'motorisation':
                    [...document.querySelectorAll(`input[name="${key}[]"]`)].forEach((input) => {
                        state[key].forEach((value) => {
                            if(input.value == value) {
                                input.checked = true;
                            }
                        });
                    });
                break;
                
                case 'pagination':
                    const page = parseInt(state[key][0], 10);
                    
                    if(!isNaN(page)) {
                        this.$paginationInput.val(page);
                    }
                break;

                case 'order':
                case 'orderby':
                    if(state?.order && state?.orderby) {
                        if(state.orderby == 'default') {
                            this.$orderInput[0].options[0].selected = true;    
                        }
                        else {
                            const orderValue = `${state.orderby}-${state.order}`;
                            
                            [...this.$orderInput[0].options].forEach((option) => {
                                if(option.value == orderValue) {
                                    option.selected = true;
                                }
                            });
                        }
                    }
                break;
            }
        }
    }

    _loadResults(replace = false, skipPushState = false) {
        const filtersValues = this._getFiltersValues();
        /*
        let filtersURL = window.location.origin + window.location.pathname + '?';
        const authorizedFiltersInURL = Object.keys(filtersValues).filter((val) => ['carrosserie', 'marque', 'modele', 'motorisation'].includes(val));
        
        authorizedFiltersInURL.forEach((key, index) => {
            const filter = filtersValues[key];

            if(Array.isArray(filter)) {
                filter.forEach((value, index2) => {
                    filtersURL += `${index === 0 && index2 === 0 ? '' : '&'}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                });
            }
        });
        
        window.history.pushState(filtersValues, '', filtersURL);
        */

        let filtersURL = `${window.location.origin}${window.location.pathname}?${new URLSearchParams(new FormData(this.$filtersForm[0])).toString()}`;

        if(!skipPushState) {
            window.history.pushState(filtersValues, '', filtersURL);
        }

        $.ajax({
            url: cha.ajax_url,
            method: 'POST',
            data: {
                action: 'render_catalog',
                nonce: cha.vehicles_catalog_nonce,
                params: filtersValues
            },
            beforeSend: this.onLoadResultsStartFn
        })
        .done(this._onLoadResultsDone.bind(this, replace))
        .always(this.onLoadResultsEndFn)
    }

    _onLoadResultsDone(replace, response) {
        if(response?.success) {
            if(response?.data?.end_reached) {
                this.endReached = true;
                this.$el.addClass('vehicles-catalog--end-reached');
            }

            if(response?.data?.html) {
                const $html = $(response.data.html);

                if(!replace) {
                    this.$vehiclesList.append($html);
                }
                else {
                    this.$vehiclesList.html($html);   
                }
                
                document.dispatchEvent(new CustomEvent('micro-simulator:refresh'));
                document.dispatchEvent(new CustomEvent('vehiclesComparator:bindLinks', {
                    detail: {
                        links: $html.filter('.vehicle-item').find('.vehicles-comparator-link')
                    }
                }));
            }
            else {
                console.log('No results found');
            }

            if(response?.data?.filters) {
                // this._unbindEvents();
                // this.noUiSlider.destroy();
                
                // this.$filtersForm.replaceWith(response.data.filters);
                // this.$filtersForm = this.$el.find('.vehicles-catalog__filters');
                // this.$priceRangeSlider = this.$el.find('.price-range-slider');
                // this.$filtersGroupsAccordions = this.$el.find('.dropdown-check-list .anchor');
                
                // this._bindEvents();
                // this._createPriceRangeSlider();
            }
            else {
                console.log('No results found');
            }
        }
    }

    _onLoadResultsStart() {
        this.isBusy = true;
        this.$el.addClass('vehicles-catalog--busy');
        this.$loadingIndicator.show();
    }

    _onLoadResultsEnd() {
        this.isBusy = false;
        this.$el.removeClass('vehicles-catalog--busy');
        this.$loadingIndicator.hide();
    }
}

export default VehiclesCatalog;

new VehiclesCatalog(document.querySelector('.vehicles-catalog'));